import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/new-content-login.png'
import _imports_1 from '@/images/login-certificata.png'


const _withScopeId = n => (_pushScopeId("data-v-6afb737a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "login-thumb" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "hero-image-fade",
    preview: false
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "hero-content" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "hero-fade hero-fade-1" }, [
      /*#__PURE__*/_createTextVNode(" Assinatura eletrônica "),
      /*#__PURE__*/_createElementVNode("span", { style: {"color":"#0664ce"} }, "segura "),
      /*#__PURE__*/_createTextVNode(" e "),
      /*#__PURE__*/_createElementVNode("span", { style: {"color":"#56c24d"} }, "confiável")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "hero-fade hero-fade-2" }, " Tecnologia e segurança para simplificar seu dia a dia e proteger o que importa. "),
    /*#__PURE__*/_createElementVNode("div", { class: "hero-features" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "hero-fade hero-fade-3" }, "🔒 Segurança ponta a ponta"),
      /*#__PURE__*/_createElementVNode("span", { class: "hero-fade hero-fade-4" }, "👥 Múltiplos signatários"),
      /*#__PURE__*/_createElementVNode("span", { class: "hero-fade hero-fade-5" }, "📄 Validade jurídica")
    ])
  ])
], -1))
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = { class: "login-wrapper" }
const _hoisted_5 = { class: "login-card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "login-content-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Acesso ao Sistema",
    preview: false
  }),
  /*#__PURE__*/_createElementVNode("h2", null, "Acesse sua conta"),
  /*#__PURE__*/_createElementVNode("span", { style: {"max-width":"300px"} }, "Entre para continuar gerenciando seus documentos com segurança.")
], -1))
const _hoisted_7 = { class: "login-content-form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "E-mail", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Senha", -1))
const _hoisted_10 = { class: "form-options" }
const _hoisted_11 = { class: "option-conected" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Manter conectado ")
const _hoisted_13 = { class: "option-recover" }
const _hoisted_14 = { class: "form-action" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Entrar com segurança", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-text" }, "ou", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ainda não tem conta?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_ArrowRightOutlined = _resolveComponent("ArrowRightOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("section", _hoisted_7, [
            _createVNode(_component_a_form, {
              layout: "vertical",
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_a_input, {
                      value: _ctx.formLogin.email,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formLogin.email) = $event)),
                      placeholder: "seu@email.com",
                      size: "large"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_MailOutlined)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_component_a_input_password, {
                      value: _ctx.formLogin.password,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formLogin.password) = $event)),
                      placeholder: "Digite sua senha",
                      size: "large"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_LockOutlined)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.formLogin.checked,
                      "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formLogin.checked) = $event)),
                      style: {"color":"#173e73"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", {
                      class: "senha",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.replace({ name: 'recuperacao' })))
                    }, " Esqueci minha senha ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    size: "larger",
                    class: "btn-action-login",
                    "html-type": "submit",
                    onClick: _ctx.login
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createVNode(_component_ArrowRightOutlined)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _hoisted_16,
                  _hoisted_17,
                  _createElementVNode("span", {
                    class: "action-new-account",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createAccount && _ctx.createAccount(...args)))
                  }, "Crie uma nova conta!")
                ])
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}